 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		116: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"default~admin-panel~a~7ec207d5","1":"vendors~admin-panel~a~5d1f16ab","2":"router-error-layout","3":"vendors~admin-panel~a~ac046c64","4":"vendors~admin-panel-r~a80638c8","5":"vendors~admin-panel-r~2d3f9aff","6":"default~app-developer~06ac6a17","7":"vendors~admin-panel-r~572d67e2","8":"default~app-layout~au~65620825","9":"vendors~app-layout~au~3dcd327a","10":"default~app-developer~2491f017","11":"default~app-developer~9a22a66a","12":"default~app-developer~fa0d8cfc","13":"vendors~app-layout~au~bed47eda","14":"default~app-layout~au~90747b74","15":"vendors~app-layout~au~a46ccca0","16":"default~app-layout~au~9d0b3661","17":"vendors~auth-login~au~17998cfa","18":"vendors~auth-login~au~a274b8dc","19":"default~auth-login~au~fff7c867","20":"vendors~app-layout~au~6bc80ff5","21":"default~app-layout~au~b9b91dfc","22":"default~book-purchase~37029e2a","23":"default~app-layout~bo~f6b7bbfa","24":"default~join~join-pay~f14d2b9b","25":"vendors~join~join-pay~8b414940","26":"default~auth-signup~b~2b8b44b8","27":"vendors~auth-signup~b~b976ab14","28":"default~auth-login~ho~69edaa01","29":"vendors~admin-panel-r~e4291acf","30":"default~collections~c~0d900781","31":"vendors~auth-welcome~~1947368f","32":"vendors~collections~c~4042232f","33":"default~auth-welcome~~77c44a96","34":"default~auth-welcome~~bdedcc7d","35":"default~collection~co~06aa196d","36":"vendors~auth-welcome~~56be291d","37":"default~collection~co~0fbe3df2","38":"vendors~collection-ne~b5b701d7","39":"default~alacarte-payw~7e1d56bc","40":"default~collection~fa~466bb45c","41":"vendors~admin-panel~a~65924968","42":"vendors~comments~noti~13a12f38","43":"default~app-layout~se~4479bbbd","44":"default~app-settings~~a968ffef","45":"default~auth-reset~web-reset","46":"default~auth-welcome~home","47":"default~book~content","48":"default~book~person","49":"default~notifications~a117e69d","50":"default~subscribe~sub~f7775a34","51":"default~user-settings~616e3fbb","52":"default~user-settings~9786616c","53":"vendors~admin-panel-r~428d7511","54":"vendors~app-developer~content","55":"vendors~auth-welcome~home","56":"vendors~book~person","57":"vendors~notifications~30618429","58":"vendors~user-settings~6217d7e4","59":"vendors~user-settings~edf3d118","60":"access-check-error-paywall","61":"account-on-hold-paywall","62":"admin-panel","63":"admin-panel-impersonate","64":"admin-panel-review-images","65":"admin-panel-ruok","66":"alacarte-debug-prices","67":"alacarte-paywall","69":"app-developer","70":"app-layout","71":"app-settings","72":"app-subscription-plan-chooser","73":"auth-login","74":"auth-reset","75":"auth-signup","76":"auth-welcome","77":"blog","78":"blogs","79":"book","80":"book-purchase","81":"books","82":"bsh-asssted-cooking","83":"collection","84":"collection-confirm-deletion","85":"collection-edit","86":"collection-new","87":"collection-unsaved-changes","88":"collections","89":"comments","90":"content","91":"embed","92":"embed-dialog","94":"favourites","95":"groceries-redirect","96":"home","97":"home-collection","98":"home-connect-menu","99":"homeconnect-claim","100":"i-cooked-this","101":"in-app-payment","102":"join","103":"join-paywall","104":"metered-access-banner","105":"not-found","106":"notifications-menu","107":"onboarding","108":"onboarding-asked","109":"onboarding-preferences","110":"onboarding-reset","111":"person","112":"premium","113":"rate-us","117":"search","118":"search-results","119":"subscribe","120":"subscribe-dialog","121":"table-of-contents","122":"unsubscribe","123":"upgrade-paywall","124":"user-membership","125":"user-membership-admin","126":"user-notifications","127":"user-settings","128":"user-settings-appearance","129":"user-settings-groceries","130":"user-settings-interests","131":"user-settings-notifications","132":"user-settings-nutrition","133":"user-settings-search","134":"user-settings-smartkitchen","135":"user-settings-units","136":"vendors~admin-panel-ruok","137":"vendors~admin-panel-r~70b77485","138":"vendors~alacarte-paywall","139":"vendors~app-developer","140":"vendors~app-settings","141":"vendors~auth-login","142":"vendors~blog","143":"vendors~blogs","144":"vendors~book-purchase","145":"vendors~books","146":"vendors~collections","147":"vendors~content","148":"vendors~metered-access-banner","149":"vendors~table-of-contents","150":"vendors~user-membership","151":"vendors~user-settings~f42fa2ed","152":"vendors~videos","153":"videos","154":"voucher-claim","155":"voucher-pending-paywall","157":"web-login","158":"web-login-changeuser","159":"web-reset","160":"web-signup"}[chunkId]||chunkId) + "." + {"0":"d554b190","1":"ff0abcc8","2":"1ad22c4d","3":"a5d8b92a","4":"b979c5d6","5":"970ebdf7","6":"0ceb48a1","7":"b5076a84","8":"ab638907","9":"f5b168e0","10":"6e9e9241","11":"7cfab0c2","12":"a2b13540","13":"a8de62cb","14":"7c70db51","15":"7eccdf37","16":"051372a1","17":"251ef4a8","18":"5581ebf8","19":"d27a137d","20":"f01ec7a2","21":"36068863","22":"2cdaf5d2","23":"643005c9","24":"978a7462","25":"8b66f35f","26":"acff0d9e","27":"67c2f74c","28":"94f8a49e","29":"10b898dc","30":"619b69f1","31":"11097b91","32":"01d1dcf6","33":"6d8ae519","34":"51f6b159","35":"1d88bfef","36":"b9caa30a","37":"0463c477","38":"6f3a3713","39":"1e400226","40":"e514fdcf","41":"dac289a1","42":"b65a0a27","43":"eb675008","44":"fc95a45d","45":"da46fcb3","46":"3b2cbfbd","47":"27b5dad2","48":"9db7c935","49":"789f4524","50":"067fabd6","51":"06998534","52":"19d01c80","53":"609035d5","54":"a3b0717a","55":"b3634093","56":"bd267ab4","57":"c49e5cc9","58":"8211af17","59":"b4525656","60":"32997929","61":"9ffb74a2","62":"48e6957c","63":"fd6fa522","64":"b90eac29","65":"b2a6e13f","66":"27549217","67":"381a4dd8","69":"67fd1723","70":"c3dbeffc","71":"90380a80","72":"0da94261","73":"ed1c1eac","74":"7a598f1d","75":"5b92452c","76":"64e160d3","77":"487090d8","78":"a06373f9","79":"be764d28","80":"2e473fc9","81":"bc180f53","82":"9107c05f","83":"c1dc45e4","84":"2d9c5149","85":"bb039113","86":"0fafa560","87":"5d898cdc","88":"c2c49ef3","89":"a3625076","90":"f3b4c4a3","91":"d4934eb4","92":"6b2d025c","94":"a495ee55","95":"9742a4a8","96":"c2113682","97":"84fbc969","98":"651f6704","99":"58db8a54","100":"fdc29f31","101":"5701e947","102":"d8b33f1c","103":"0631bcf2","104":"59a3d029","105":"b9b33f4f","106":"dceafe58","107":"67a0fed3","108":"952062ec","109":"f8596d21","110":"f3aaf128","111":"460bf256","112":"9d4463be","113":"d6fdd1d7","117":"7eaaa8bb","118":"b9cce1e2","119":"1f2f7b09","120":"37a2d9a1","121":"a0c4b6eb","122":"0c119993","123":"55f5c156","124":"137f56e6","125":"a762e8b3","126":"47091481","127":"61a80beb","128":"a8eafe3e","129":"4dfbe673","130":"e87e3e3b","131":"bda3477a","132":"4d89df0c","133":"92c591b8","134":"e6905faf","135":"30602bdf","136":"68a63993","137":"a1f36f1e","138":"b24812ef","139":"54bc7ab7","140":"00a64533","141":"2b43099a","142":"9aa1c426","143":"d419ad1a","144":"20cc1bf0","145":"666f2e78","146":"8846c3b4","147":"dd94bcda","148":"7aee0f10","149":"178778e7","150":"a59e0e20","151":"82323a7d","152":"f72247fd","153":"32e9b6d3","154":"1ff3dbe9","155":"43252e26","157":"87fc1b17","158":"c22530e5","159":"51ffb5b9","160":"9b5cc613"}[chunkId] + ".chunk.legacy.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
